import { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import Header from '../Header/Header';
import { PageProps } from './Page.types';

import styles from './Page.module.css';

export const Page = ({ title, header, breadcrumb, children, gap = 4 }: PropsWithChildren<PageProps>) => (
  <>
    <Header title={title} breadcrumb={breadcrumb} />
    <Box paddingTop={5.25} paddingX={8} paddingBottom={2.5} gap={gap} display="flex" flexDirection="column">
      <h1 className={styles.title}>{header}</h1>
      {children}
    </Box>
  </>
);
